import React from "react";
import MainLayout from "../mainLayout";
import { Col, Row } from "react-bootstrap";
import TabWidget from "../../components/tabWidget";

const NavLayout = ({ children }) => {
  return (
    <MainLayout>
      <Row className="nav-layout">
        <Col md={2} className="nav-layout-left">
         <TabWidget/>
        </Col>
        <Col md={10}>
          {children}
        </Col>
      </Row>
    </MainLayout>
  );
};

export default NavLayout;
